document.addEventListener("DOMContentLoaded", function () {
  const slideInItems = document.querySelectorAll(".slide-up-animated");
  if (!slideInItems) return;
  slideInItems.forEach((item) => {
    item.classList.add("animation-start");
  });
});
function getSliderSettings() {
  return {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
}

function getSubSliderProductSettings() {
  return {
    slidesPerView: "auto",
    direction: "vertical",
    navigation: false,
  };
}

const sliderInit = (isUpdate) => {
  const swiperElements = document.querySelectorAll(
    ".product-section .js-media-list"
  );
  if (swiperElements && swiperElements.length > 0) {
    const dir = document.querySelector("html").getAttribute("dir");

    let nextEl = ".swiper-btn--next";
    let prevEl = ".swiper-btn--prev";
    const swiperElement = swiperElements[0];
    const enableLoop = swiperElement.dataset.enableLoop == "true";

    if (dir === "rtl") {
      [nextEl, prevEl] = [prevEl, nextEl];
    }

    if (swiperElement.swiper) {
      swiperElement.swiper.destroy(true, true);
    }

    let slider = new Swiper(swiperElement, {
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl,
        prevEl,
      },
      loop: enableLoop,
      pagination: {
        el: `.slider-pagiantion-bullet .swiper-pagination`,
        clickable: "true",
        type: "bullets",
        renderBullet: function (activeIndex, className) {
          return (
            '<span class="' +
            className +
            '">' +
            "<em>" +
            activeIndex +
            "</em>" +
            "<i></i>" +
            "<b></b>" +
            "</span>"
          );
        },
      },
      thumbs: {
        swiper: document.querySelector(".product-section .js-media-sublist")
          .swiper,
      },
      on: {
        slideChangeTransitionStart: function () {
          document
            .querySelector(".product-section .js-media-sublist")
            .swiper.slideTo(
              document.querySelector(".product-section .js-media-list").swiper
                .activeIndex
            );
        },
        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            this.slides[this.activeIndex]
              .querySelector(".shopify-model-viewer-ui__button--poster")
              .removeAttribute("hidden");
          }
        },
        imagesReady: function () {
          this.updateAutoHeight();
        },
        touchStart: function (s, e) {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if (
              !this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            }
          }
        },
      },
    });
    if (isUpdate) {
      setTimeout(function () {
        slider.update();
      }, 800);
    }
  }
};

const subSliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".product-section .js-media-sublist") &&
    document.querySelectorAll(".product-section .js-media-sublist").length > 0
  ) {
    const sliderElem = document.querySelector(
      ".product-section .js-media-sublist"
    );
    const sliderType = sliderElem.dataset.sliderType;
    const productMediaWrapper = sliderElem.closest(".product__media-wrapper");
    const mainSliderElem = productMediaWrapper.querySelector(
      ".product-section .js-media-list"
    );

    let prevEl = ".swiper-sub-btn--prev";
    let nextEl = ".swiper-sub-btn--next";

    let navigation =
      sliderType === "thumbnail-slider"
        ? {
            nextEl,
            prevEl,
          }
        : false;

    const nextButton = sliderElem?.querySelector(nextEl);
    const prevButton = sliderElem?.querySelector(prevEl);

    if (sliderElem.swiper) {
      sliderElem.swiper.destroy(true, true);
    }

    let subSlider = new Swiper(sliderElem, {
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesPerView: 3,
      spaceBetween: 24,
      direction: "horizontal",
      navigation: false,
      freeMode: false,
      watchSlidesProgress: true,
      navigation: navigation,
      on: {
        touchEnd: function (s, e) {
          let range = 5;
          let diff = (s.touches.diff = s.isHorizontal()
            ? s.touches.currentX - s.touches.startX
            : s.touches.currentY - s.touches.startY);
          if (diff < range || diff > -range) s.allowClick = true;
        },
      },
      transitionStart: function () {
        document
          .querySelector(".product-section .js-media-list")
          .swiper.slideTo(
            document.querySelector(".product-section.js-media-sublist").swiper
              .activeIndex
          );
      },
      breakpoints: {
        1100: {
          direction: "vertical",
          slidesPerView: "auto",
          centeredSlides: false,
          allowTouchMove: false,
        },
      },
      cssMode: true,
    });

    nextButton?.addEventListener("click", () => {
      if (mainSliderElem.swiper) {
        mainSliderElem.swiper.slideNext();
      }
    });

    prevButton?.addEventListener("click", () => {
      if (mainSliderElem.swiper) {
        mainSliderElem.swiper.slidePrev();
      }
    });

    if (sliderType === "thumbnail-slider" && window.innerWidth > 1100) {
      const sliderResizeObserve = new ResizeObserver(() => {
        setTimeout(() => {
          const subSliderEl = document.querySelector(".js-media-list");
          const thumbEl = document.querySelector(".product__media-sublist");

          if (subSliderEl && thumbEl) {
            const sliderHeight = subSliderEl.getBoundingClientRect().height;
            thumbEl.style.height = `${sliderHeight - 1}px`;
          }
        }, 400);
      });

      if (document.querySelector(".product-section")) {
        sliderResizeObserve.observe(document.querySelector(".product-section"));
      }
    }

    if (isUpdate) {
      setTimeout(function () {
        subSlider.update();
      }, 800);
    }
  }
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.onCartChange = this.handleCartChange.bind(this);

    if (!this.input) return;

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    const minValue = Number(this.input.min || 1);
    const fallbackValue = minValue > 0 ? 1 : 0;
    const numberRegex = minValue > 0 ? /^0*?[1-9]\d*$/ : /^\d+$/;

    var eventList = ["paste", "input"];

    for (const event of eventList) {
      this.input.addEventListener(event, (e) => {
        if (
          numberRegex.test(e.currentTarget.value) ||
          e.currentTarget.value === ""
        ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = fallbackValue;
        }

        this.setMinimumDisable();
      });
    }

    this.input.addEventListener("focusout", (e) => {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = fallbackValue;
      }

      this.setMinimumDisable();
    });

    this.setMinimumDisable();
  }

  connectedCallback() {
    document.addEventListener("cart:change", this.onCartChange);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:change", this.onCartChange);
  }

  setMinimumDisable() {
    const minusBtn = this.querySelector('button[name="minus"]');

    if (!this.input) return;

    if (minusBtn) {
      if (Number(this.input.value) <= Number(this.input.min || 1)) {
        minusBtn.classList.add("disabled");
      } else {
        minusBtn.classList.remove("disabled");
      }
    }

    this.updateDynamicUnitPrice();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.setMinimumDisable();
  }

  handleCartChange(event) {
    if (!this.input) return;

    const variantInput = this.closest("form")?.querySelector('[name="id"]');
    const variantId = Number(variantInput?.value);

    if (!variantId || Number.isNaN(variantId)) return;

    const cartItems = event.detail?.cart?.items;
    if (!Array.isArray(cartItems)) return;

    const cartQuantity = cartItems.reduce((total, item) => {
      return item.variant_id === variantId
        ? total + Number(item.quantity || 0)
        : total;
    }, 0);

    this.input.dataset.cartQuantity = String(cartQuantity);
    this.updateDynamicUnitPrice();
  }

  updateDynamicUnitPrice() {
    const unitPriceContainer = this.closest(
      ".product-form__quantity"
    )?.querySelector("[data-volume-pricing-display]");

    if (!unitPriceContainer || !this.input) return;

    let pricingBreaks = [];

    try {
      pricingBreaks = JSON.parse(
        unitPriceContainer.dataset.volumePricing || "[]"
      );
    } catch (error) {
      return;
    }

    if (!Array.isArray(pricingBreaks) || pricingBreaks.length === 0) return;

    const quantity = Number(this.input.value || this.input.min || 1);
    const cartQuantity = Number(this.input.dataset.cartQuantity || 0);
    const totalQuantity =
      quantity + (Number.isNaN(cartQuantity) ? 0 : cartQuantity);
    const activePriceBreak = pricingBreaks.reduce(
      (currentPriceBreak, priceBreak) => {
        const minimumQuantity = Number(priceBreak.minimum_quantity);

        if (
          !Number.isNaN(minimumQuantity) &&
          totalQuantity >= minimumQuantity
        ) {
          return priceBreak;
        }

        return currentPriceBreak;
      },
      pricingBreaks[0]
    );

    const unitPriceValue = unitPriceContainer.querySelector(
      ".product-form__unit-price-value"
    );

    if (unitPriceValue && activePriceBreak?.price) {
      unitPriceValue.textContent = activePriceBreak.price;
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class AnchoredPopoverComponent extends HTMLElement {
  constructor() {
    super();

    this.interactionDelay = 200;
    this.popoverTrigger = null;
    this.trigger = null;
    this.popoverElement = null;
    this.verticalPositionAnchor = null;

    this.onTriggerEnter = this.handleTriggerEnter.bind(this);
    this.onTriggerLeave = this.handleTriggerLeave.bind(this);
    this.onPopoverEnter = this.handlePopoverEnter.bind(this);
    this.onPopoverLeave = this.handlePopoverLeave.bind(this);
    this.onBeforeToggle = this.handleBeforeToggle.bind(this);
    this.onResize = debounce(this.handleResize.bind(this), 100);
  }

  connectedCallback() {
    this.refreshRefs();

    if (!this.trigger || !this.popoverElement) return;

    this.popoverElement.addEventListener("beforetoggle", this.onBeforeToggle);

    if (this.dataset.hoverTriggered === "true") {
      this.trigger.addEventListener("pointerenter", this.onTriggerEnter);
      this.trigger.addEventListener("pointerleave", this.onTriggerLeave);
      this.popoverElement.addEventListener("pointerenter", this.onPopoverEnter);
      this.popoverElement.addEventListener("pointerleave", this.onPopoverLeave);
    }

    window.requestAnimationFrame(() => {
      this.updatePosition();
    });
  }

  disconnectedCallback() {
    if (this.popoverElement) {
      this.popoverElement.removeEventListener(
        "beforetoggle",
        this.onBeforeToggle
      );
      this.popoverElement.removeEventListener(
        "pointerenter",
        this.onPopoverEnter
      );
      this.popoverElement.removeEventListener(
        "pointerleave",
        this.onPopoverLeave
      );
    }

    if (this.trigger) {
      this.trigger.removeEventListener("pointerenter", this.onTriggerEnter);
      this.trigger.removeEventListener("pointerleave", this.onTriggerLeave);
    }

    if (this.popoverTrigger !== null) {
      clearTimeout(this.popoverTrigger);
      this.popoverTrigger = null;
    }

    window.removeEventListener("resize", this.onResize);
  }

  updatedCallback() {
    this.refreshRefs();
    this.updatePosition();
  }

  refreshRefs() {
    this.trigger = this.querySelector('[ref="trigger"]');
    this.popoverElement = this.querySelector('[ref="popover"]');
    this.verticalPositionAnchor = this.querySelector(
      '[ref="verticalPositionAnchor"]'
    );
  }

  handleTriggerEnter() {
    if (!this.trigger || !this.popoverElement) return;

    this.trigger.dataset.hoverActive = "true";

    if (typeof this.popoverElement.showPopover !== "function") return;
    if (this.popoverElement.matches(":popover-open")) return;

    this.popoverTrigger = window.setTimeout(() => {
      if (this.trigger?.matches("[data-hover-active]")) {
        this.popoverElement.showPopover();
      }
    }, this.interactionDelay);
  }

  handleTriggerLeave() {
    if (!this.trigger || !this.popoverElement) return;

    delete this.trigger.dataset.hoverActive;

    if (this.popoverTrigger !== null) {
      clearTimeout(this.popoverTrigger);
      this.popoverTrigger = null;
    }

    if (typeof this.popoverElement.hidePopover !== "function") return;
    if (!this.popoverElement.matches(":popover-open")) return;

    this.popoverTrigger = window.setTimeout(() => {
      this.popoverElement?.hidePopover();
    }, this.interactionDelay);
  }

  handlePopoverEnter() {
    if (this.popoverTrigger !== null) {
      clearTimeout(this.popoverTrigger);
      this.popoverTrigger = null;
    }
  }

  handlePopoverLeave() {
    if (
      !this.popoverElement ||
      typeof this.popoverElement.hidePopover !== "function"
    ) {
      return;
    }

    this.popoverTrigger = window.setTimeout(() => {
      this.popoverElement?.hidePopover();
    }, this.interactionDelay);
  }

  handleBeforeToggle(event) {
    if (!this.popoverElement) return;

    if (event.newState === "open") {
      this.updatePosition();

      if (this.dataset.closeOnResize === "true") {
        window.addEventListener("resize", this.onResize);
      }
    } else {
      window.removeEventListener("resize", this.onResize);
    }
  }

  handleResize() {
    if (!this.popoverElement) return;

    if (this.dataset.closeOnResize === "true") {
      if (
        this.popoverElement.matches(":popover-open") &&
        typeof this.popoverElement.hidePopover === "function"
      ) {
        this.popoverElement.hidePopover();
      }

      return;
    }

    this.updatePosition();
  }

  getVerticalPositionAnchor() {
    if (this.verticalPositionAnchor instanceof HTMLElement) {
      return this.verticalPositionAnchor;
    }

    const anchorName = this.dataset.verticalPositionAnchor?.trim();
    if (!anchorName) return null;

    const selector = `[data-anchor-name="${CSS.escape(anchorName)}"]`;
    const scope = this.closest(
      "[data-anchor-scope], tr, li, section, article, form"
    );
    const scopedAnchor = scope?.querySelector(selector);

    if (scopedAnchor instanceof HTMLElement) return scopedAnchor;

    const root = this.getRootNode();
    const rootAnchor =
      root instanceof Document || root instanceof ShadowRoot
        ? root.querySelector(selector)
        : null;

    return rootAnchor instanceof HTMLElement ? rootAnchor : null;
  }

  updatePosition() {
    if (!this.popoverElement || !this.trigger) return;

    const triggerRect = this.trigger.getBoundingClientRect();
    const verticalAnchor = this.getVerticalPositionAnchor() || this.trigger;
    const verticalRect = verticalAnchor.getBoundingClientRect();

    this.popoverElement.style.setProperty(
      "--anchor-top",
      `${verticalRect.top}`
    );
    this.popoverElement.style.setProperty(
      "--anchor-right",
      `${window.innerWidth - triggerRect.right}`
    );
    this.popoverElement.style.setProperty(
      "--anchor-bottom",
      `${window.innerHeight - verticalRect.bottom}`
    );
    this.popoverElement.style.setProperty(
      "--anchor-left",
      `${triggerRect.left}`
    );
    this.popoverElement.style.setProperty(
      "--anchor-height",
      `${verticalRect.height}`
    );
    this.popoverElement.style.setProperty(
      "--anchor-width",
      `${triggerRect.width}`
    );
  }
}

if (!customElements.get("anchored-popover-component")) {
  customElements.define("anchored-popover-component", AnchoredPopoverComponent);
}

class VolumePricingInfo extends HTMLElement {
  connectedCallback() {
    this.closest("anchored-popover-component")?.updatedCallback?.();

    const quantityInput = this.getQuantityInput();
    const quantity = Number(quantityInput?.value || quantityInput?.min || 1);

    this.updateActiveTier(quantity);
  }

  updatedCallback() {
    this.closest("anchored-popover-component")?.updatedCallback?.();
  }

  getQuantityInput() {
    return this.closest("cart-quantity-selector-component")?.querySelector(
      'input[type="number"]'
    );
  }

  updateActiveTier(quantity) {
    const popover = this.closest("anchored-popover-component")?.querySelector(
      '[ref="popover"]'
    );
    const rows = popover?.querySelectorAll(
      ".cart-volume-pricing-info__row[data-quantity]"
    );

    if (!rows?.length) return;

    let activeTier = null;

    rows.forEach((row) => {
      row.classList.remove("cart-volume-pricing-info__row--active");

      if (!(row instanceof HTMLElement)) return;

      if (quantity >= Number(row.dataset.quantity || 0)) {
        activeTier = row;
      }
    });

    activeTier?.classList.add("cart-volume-pricing-info__row--active");
  }
}

if (!customElements.get("volume-pricing-info")) {
  customElements.define("volume-pricing-info", VolumePricingInfo);
}

class CartQuantitySelectorComponent extends HTMLElement {
  constructor() {
    super();

    this.syncPopoverState = this.handleQuantityChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("input", this.syncPopoverState);
    this.addEventListener("change", this.syncPopoverState);
    this.handleQuantityChange();
  }

  disconnectedCallback() {
    this.removeEventListener("input", this.syncPopoverState);
    this.removeEventListener("change", this.syncPopoverState);
  }

  handleQuantityChange() {
    const quantityInput = this.querySelector('input[type="number"]');
    const volumePricingInfo = this.querySelector("volume-pricing-info");

    if (!quantityInput || !volumePricingInfo) return;

    const quantity = Number(quantityInput.value || quantityInput.min || 1);

    if (typeof volumePricingInfo.updateActiveTier === "function") {
      volumePricingInfo.updateActiveTier(quantity);
    }

    this.querySelector("anchored-popover-component")?.updatedCallback?.();
  }
}

if (!customElements.get("cart-quantity-selector-component")) {
  customElements.define(
    "cart-quantity-selector-component",
    CartQuantitySelectorComponent
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    //if (navigator.platform === "iPhone")
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    } else if (
      document.body.classList.contains(
        `overflow-hidden-${this.dataset.breakpoint}`
      )
    ) {
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    // bind once
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handlePointerUp = this.handlePointerUp.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);

    this.init();
  }

  init() {
    // remove previous dynamic listeners
    this.destroy();

    // close button inside replaced content
    this.closeButton = this.querySelector('[id^="ModalClose-"]');

    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleCloseClick);
    }

    // static modal listeners
    this.addEventListener("keyup", this.handleEscape);

    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", this.handlePointerUp);
    } else {
      this.addEventListener("click", this.handleBackdropClick);
    }
  }

  destroy() {
    if (this.closeButton) {
      this.closeButton.removeEventListener("click", this.handleCloseClick);
    }

    this.removeEventListener("keyup", this.handleEscape);
    this.removeEventListener("pointerup", this.handlePointerUp);
    this.removeEventListener("click", this.handleBackdropClick);
  }

  handleCloseClick() {
    this.hide();
  }

  handleEscape(event) {
    if (event.code.toUpperCase() === "ESCAPE") {
      this.hide();
    }
  }

  handlePointerUp(event) {
    if (
      event.pointerType === "mouse" &&
      !event.target.closest("deferred-media, product-model")
    ) {
      this.hide();
    }
  }

  handleBackdropClick(event) {
    if (event.target === this) {
      this.hide();
    }
  }

  reinit() {
    this.init();
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      if (
        !document.querySelector("#search-modal")?.classList.contains("active")
      ) {
        document.body.classList.remove("overflow-hidden");
      }
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

function isSafari() {
  const userAgent = navigator.userAgent;
  return /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
}
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
  }

  openSelector() {
    if (
      isSafari() &&
      this.elements.button.getAttribute("is-button-clicked") === "true"
    ) {
      return;
    }

    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();

      if (isSafari()) {
        this.elements.button.setAttribute("is-button-clicked", "true");

        setTimeout(() => {
          this.elements.button.setAttribute("is-button-clicked", "false");
        }, 150);
      }
    }
  }
}

customElements.define("localization-form", LocalizationForm);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.getAttribute("data-autoplay")) {
              let playPromise = entry.target.play();
              if (playPromise !== undefined) {
                playPromise.then((_) => {}).catch((error) => {});
              }
            }
          } else {
            entry.target.pause();
          }
        });
      });
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (
        deferredElement.nodeName == "VIDEO" ||
        deferredElement.nodeName == "IFRAME"
      ) {
        // force autoplay for safari

        if (this.classList.contains("video-section__media")) {
          let playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
          }
          videoObserver.observe(deferredElement);
        } else {
          deferredElement.play();
        }
      }
      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
              this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    this.sliderItems = this.querySelectorAll(".slider__slide");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.combinedProductURL = "";
    this.infoBlocksList = [
      "Tags",
      "Vendor",
      "Desc",
      "Desc-title",
      "Desc-context",
      "About-title",
      "About-context",
      "ProductModal",
    ];
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;
    const selectedValuesIds = this.getSelectedValuesIds();

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);

    this.isHighVariantNeedUpdate = false;

    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && this.combinedProductURL)
    ) {
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: this.combinedProductURL,
      });

      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
      }
      if (this.combinedProductURL) {
        this.isCombinedListingsNeedUpdate = true;
      }
    }

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }

    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (
        this.currentVariant?.featured_media &&
        this.dataset?.variantMediaDisplay === "show_all"
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        this.updateMediaSub();
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
        combinedProductURL: this.combinedProductURL,
      });
      this.renderProductInfo(requestUrl);
    }

    if (this.currentVariant) {
      document.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
            previousVariant: this.previousVariant || null,
            formElement: document.querySelector(`#${this.getAttribute("id")}`),
            sectionId: this.dataset.section,
          },
        })
      );

      // Save the previous version
      this.previousVariant = this.currentVariant;
    }
  }

  updateOptions() {
    const fieldsets = [...this.querySelectorAll("fieldset")];

    fieldsets.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    this.options = fieldsets.map((fieldset) => {
      const select = fieldset.querySelector("select");
      const value = select
        ? select.value
        : Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value;
      this.updateSelectedColorName(fieldset, value);
      return value;
    });
  }

  updateSelectedColorName(fieldset, value) {
    const span = fieldset.querySelector(".product-form__selected-color-value");
    if (span) span.textContent = value;
  }

  getSelectedValuesIds() {
    const controls = [
      ...this.querySelectorAll(".product-form__controls"),
      ...this.querySelectorAll(".product-form__input"),
    ];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      const selectedOption = control.querySelector("select option:checked");

      if (checkedInput?.dataset?.productUrl) {
        this.combinedProductURL = checkedInput.dataset.productUrl;
      }

      if (selectedOption?.dataset?.productUrl) {
        this.combinedProductURL = selectedOption.dataset.productUrl;
      }

      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : selectedOption?.dataset?.optionValueId
        ? selectedOption?.dataset?.optionValueId
        : null;
    });
  }

  createRequestUrl({
    combinedProductURL = "",
    currentVariantId = "",
    selectedValuesIds = [],
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  // !!! Need to add for update data
  setCurrentVariantAfterFetch(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource =
      html.getElementById(`variant-radios-${sourceSectionId}`) ||
      html.getElementById(`variant-selects-${sourceSectionId}`);

    const variantPickerDestination =
      document.getElementById(`variant-radios-${currentSectionId}`) ||
      document.getElementById(`variant-selects-${currentSectionId}`);

    if (!variantPickerSource) return;

    if (
      variantPickerSource.dataset.url != variantPickerDestination.dataset.url
    ) {
      this.dataset.url = variantPickerSource.dataset.url;
    }

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestination.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        //this.options.sort();
        //variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const parent = newMedia.parentElement;

    parent.prepend(newMedia);

    window.setTimeout(() => {
      parent.scroll(0, 0);
    });

    if (document.querySelector(".js-media-list")) {
      sliderInit();
    }
  }

  updateMediaSub() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMediaSub = document.querySelector(
      `[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (
      document.querySelector(".js-media-sublist") &&
      document.querySelector(".js-media-sublist").swiper != null
    ) {
      document.querySelector(".js-media-sublist").swiper.destroy();
    }

    if (!newMediaSub) return;

    const parentSub = newMediaSub.parentElement;

    parentSub.prepend(newMediaSub);

    window.setTimeout(() => {
      parentSub.scroll(0, 0);
    });

    if (document.querySelector(".js-media-sublist")) {
      subSliderInit();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  resetErrorMessage() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections

        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {
          console.log(err);
        }

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (
                this.currentVariant.featured_media &&
                this.dataset?.variantMediaDisplay === "show_all"
              ) {
                // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
                this.updateMedia();
              }
            }
          } catch (err) {
            console.log(err);
          }
        }
        // -----
        this.updateElementsAfterFetch(html);

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant?.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource =
      html.getElementById(`variant-radios-${sourceSectionId}`) ||
      html.getElementById(`variant-selects-${sourceSectionId}`);

    const variantPickerDestination =
      document.getElementById(`variant-radios-${currentSectionId}`) ||
      document.getElementById(`variant-selects-${currentSectionId}`);

    if (variantPickerSource && variantPickerDestination) {
      const quickViewModal = this.closest("quick-view-modal");
      const quicAddModal = this.closest("quick-add-modal");

      let preSel = "quickview";
      if (quicAddModal) {
        preSel = "quickadd";
      }

      if (quickViewModal || quicAddModal) {
        variantPickerDestination.innerHTML =
          variantPickerSource.innerHTML.replaceAll(
            sourceSectionId,
            `${preSel}-${sourceSectionId}`
          );
      } else {
        variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
      }
    }
  }

  updateElementsAfterFetch(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const quickViewModal = this.closest("quick-view-modal");
    const quicAddModal = this.closest("quick-add-modal");

    const destination = document.getElementById(
      `price-${this.dataset.section}`
    );
    const source = html.getElementById(
      `price-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    );
    const skuSource = html.getElementById(
      `Sku-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    );
    const skuDestination = document.getElementById(
      `Sku-${this.dataset.section}`
    );
    const inventorySource = html.getElementById(
      `Inventory-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    );
    const inventoryDestination = document.getElementById(
      `Inventory-${this.dataset.section}`
    );

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (inventorySource && inventoryDestination)
      inventoryDestination.innerHTML = inventorySource.innerHTML;
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    const price = document.getElementById(`price-${this.dataset.section}`);

    if (price) price.classList.remove("visibility-hidden");

    if (inventoryDestination)
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );

    const addButtonUpdated = html.getElementById(
      `ProductSubmitButton-${sourceSectionId}`
    );

    const productButtonsSource = html.querySelector(
      `[data-id="ProductButtons-${sourceSectionId}"]`
    );
    const productButtonsDestination = document.querySelectorAll(
      `[data-id="ProductButtons-${currentSectionId}"]`
    );

    if (productButtonsSource) {
      const sourceButtonsWrapper = productButtonsSource.querySelector(
        ".product-form__buttons"
      );

      productButtonsDestination.forEach((el) => {
        const buttonsWrapper = el.querySelector(".product-form__buttons");

        if (!sourceButtonsWrapper || !buttonsWrapper) return;

        const sourceHasQuantityPricing =
          sourceButtonsWrapper.dataset.hasQuantityPricing === "true";
        const destHadQuantityPricing =
          buttonsWrapper.dataset.hasQuantityPricing === "true";

        if (sourceHasQuantityPricing || destHadQuantityPricing) {
          if (sourceHasQuantityPricing) {
            buttonsWrapper.dataset.hasQuantityPricing = "true";
          } else {
            buttonsWrapper.removeAttribute("data-has-quantity-pricing");
          }

          const sourceB2bEl = sourceButtonsWrapper.querySelector(
            ".product-b2b-elements"
          );
          const destB2bEl = buttonsWrapper.querySelector(
            ".product-b2b-elements"
          );

          if (sourceB2bEl && destB2bEl) {
            destB2bEl.innerHTML = sourceB2bEl.innerHTML;
          } else if (sourceB2bEl && !destB2bEl) {
            buttonsWrapper.insertAdjacentHTML(
              "afterbegin",
              sourceB2bEl.outerHTML
            );
          } else if (!sourceB2bEl && destB2bEl) {
            destB2bEl.remove();
          }

          const sourceQuantityWrapper = sourceButtonsWrapper.querySelector(
            ".product-form__quantity"
          );
          const destQuantityWrapper = buttonsWrapper.querySelector(
            ".product-form__quantity"
          );

          if (sourceQuantityWrapper && destQuantityWrapper) {
            const quantityWrapperHtml =
              quickViewModal || quicAddModal
                ? sourceQuantityWrapper.innerHTML.replaceAll(
                    sourceSectionId,
                    currentSectionId
                  )
                : sourceQuantityWrapper.innerHTML;

            destQuantityWrapper.innerHTML = quantityWrapperHtml;

            const quantityInput =
              destQuantityWrapper.querySelector("quantity-input");
            if (
              quantityInput &&
              typeof quantityInput.setMinimumDisable === "function"
            ) {
              quantityInput.setMinimumDisable();
            }
          }
        }
      });
    }

    // Update Info blocks and Modals
    this.updateProductInfoBlocks(html);

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const variantSwatchesSource = html.querySelector(
        `#variant-radios-${sourceSectionId} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = document.querySelector(
        `#variant-radios-${currentSectionId} [data-is-variant-image-swatch="true"]`
      );

      if (variantSwatchesSource && variantSwatchesDestination) {
        const quickViewModal = this.closest("quick-view-modal");
        if (quickViewModal) {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML.replaceAll(
              sourceSectionId,
              `quickview-${sourceSectionId}`
            );
        } else {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML;
        }
      }
    }

    // product media
    if (
      this.dataset?.variantMediaDisplay !== "show_all" ||
      this.isCombinedListingsNeedUpdate
    ) {
      const sourceSectionId = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
      const currentSectionId = this.dataset.section;

      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = document.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );

      if (mediaSource && mediaDestination) {
        mediaDestination.innerHTML = mediaSource.innerHTML;

        const parentQuickView = this.closest("quick-view-modal");
        if (parentQuickView) {
          if (typeof parentQuickView.removeDOMElements === "function") {
            parentQuickView.removeDOMElements(mediaDestination);
          }
          if (typeof parentQuickView.initSlider === "function") {
            parentQuickView.initSlider();
          }
        } else {
          const section = document.getElementById(
            `shopify-section-${currentSectionId}`
          );

          if (section && typeof initProductPage === "function") {
            initProductPage(section);
          }
        }
        if (document.querySelector(".js-media-list")) {
          if (currentSectionId.includes("quickadd")) {
            quickAddSliderInit_G(true);
          } else {
            subSliderInit(true);
            sliderInit(true);
          }
        }
      }
    }
    if (this.isCombinedListingsNeedUpdate) {
      const newVariantData = html.querySelector(
        "[data-selected-variant]"
      ).innerHTML;

      const selectedVariant = !!newVariantData
        ? JSON.parse(newVariantData)
        : null;

      let productTitle = selectedVariant?.name?.replace(
        `- ${selectedVariant?.title}`,
        ""
      );

      if (!productTitle) {
        productTitle = html.querySelector(".product__title")?.innerHTML
          ? html.querySelector(".product__title")?.innerHTML.trim()
          : "";
      }

      // product title
      const titleDestination = document.querySelectorAll(".product__title");
      if (titleDestination) {
        titleDestination.forEach((titleElem) => {
          titleElem.innerText = productTitle || "";
        });
      }

      //breadcrumb
      const breadcrumbDestination = document.querySelector(".breadcrumb span");
      if (breadcrumbDestination) {
        breadcrumbDestination.innerText = productTitle || "";
      }

      // text
      const textDestination = document.querySelector(
        ".product .product__info-wrapper .product__text"
      );

      if (textDestination) {
        textDestination.innerHTML =
          html.querySelector(".product .product__info-wrapper .product__text")
            ?.innerHTML || "";
      }

      // about
      const aboutDestination = document.querySelector(
        ".product .product__outer .about"
      );

      if (aboutDestination) {
        aboutDestination.innerHTML =
          html.querySelector(".product .product__outer .about")?.innerHTML ||
          "";
      }

      // product buttons
      const buttonsDestination = document.querySelectorAll(
        ".product .product__outer .product-form .form"
      );
      if (buttonsDestination) {
        buttonsDestination.forEach((titleElem) => {
          titleElem.innerHTML =
            html?.querySelector(".product .product__outer .product-form .form")
              ?.innerHTML || "";
        });
      }
    }
  }

  updateProductInfoBlocks(html) {
    const sourceId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const destId = this.dataset.section;

    this.infoBlocksList.forEach((block) => {
      const blockSource = html.getElementById(`${block}-${sourceId}`);

      const blockDestination = document.getElementById(`${block}-${destId}`);

      if (blockDestination) {
        blockDestination.innerHTML = blockSource?.innerHTML || "";

        // Check if the modal element exists and reinitialize it
        const isDialog = blockDestination.querySelector('[role="dialog"]');
        if (isDialog && typeof blockDestination?.reinit === "function") {
          blockDestination.reinit();
        }
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelectorAll('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");

      if (text) {
        addButtonText.forEach((elem) => {
          elem.innerHTML = `${text}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
        });
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.forEach((elem) => {
        elem.innerHTML = `${window.variantStrings.addToCart}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelectorAll('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.forEach((elem) => {
      elem.innerHTML = `${window.variantStrings.unavailable}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
</svg>`;
    });
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const value = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
      this.updateSelectedColorName(fieldset, value);
      return value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );

    const $this = this;

    this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
      "click",
      function () {
        if (
          $this
            .closest(".swiper")
            .swiper.slides[
              $this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
        ) {
          if (
            !$this
              .closest(".swiper")
              .swiper.slides[
                $this.closest(".swiper").swiper.activeIndex
              ].querySelector("model-viewer")
              .classList.contains("shopify-model-viewer-ui__disabled")
          ) {
            if (
              $this
                .querySelector(".shopify-model-viewer-ui__button")
                .hasAttribute("hidden")
            ) {
              $this.closest(".swiper").swiper.params.noSwiping = true;
              $this.closest(".swiper").swiper.params.noSwipingClass =
                "swiper-slide";
            }
          }
        }
      }
    );

    this.querySelector(
      ".shopify-model-viewer-ui__controls-overlay"
    ).addEventListener("click", function () {
      if (
        !$this
          .querySelector(".shopify-model-viewer-ui__button")
          .hasAttribute("hidden")
      ) {
        $this.closest(".swiper").swiper.params.noSwiping = false;
      }
    });
  }
}
customElements.define("product-model", ProductModel);

// Product slider

(function () {
  const productSlider = () => {
    const productSliders = Array.from(
      document.querySelectorAll(".products-slider")
    );
    const dir = document.querySelector("html").getAttribute("dir");

    if (productSliders.length === 0) return;
    productSliders.forEach((slider) => {
      const sectionId = slider.dataset.id;
      const perRow = slider.dataset.perRow;
      const speed = slider.dataset.speed * 1000;
      const delay = slider.dataset.delay * 1000;
      const autoplay = toBoolean(slider.dataset.autoplay);
      const stopAutoplay = toBoolean(slider.dataset.stopAutoplay);
      const showArrows = toBoolean(slider.dataset.showArrows);
      const enableHashNavigation = toBoolean(slider.dataset.enableHashNavigation);
      let autoplayParm = {};
      let arrowsParm = {};
      let hashNavigationParm = {};
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      }

      let nextEl = `#${sectionId} .swiper-button-next`;
      let prevEl = `#${sectionId} .swiper-button-prev`;

      if (dir === "rtl") {
        [nextEl, prevEl] = [prevEl, nextEl];
      }

      if (showArrows) {
        arrowsParm = {
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: {
            el: `#${sectionId} .swiper-pagination`,
            clickable: true,
          },
        };
      }

      if (enableHashNavigation) {
        hashNavigationParm = {
          hashNavigation: {
            watchState: true,
            replaceState: true,
          },
        };
      }
      let swiperParms = {
        speed: speed,
        keyboard: true,
        slidesPerView: 1,
        spaceBetween: 16,
        on: {
          init: function () {
            if (showArrows) {
              changePosition(sectionId);
            }
          },
          resize: debounce(function () {
            if (showArrows) {
              changePosition(sectionId);
            }
          }, 300),
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          1100: {
            spaceBetween: 24,
            slidesPerView: perRow,
          },
        },
        ...arrowsParm,
        ...autoplayParm,
        ...hashNavigationParm,
      };

      const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms);
    });
  };

  function changePosition(sectionId) {
    if (window.innerWidth < 1100) return;

    const mediaElement = document.querySelector(
      `#${sectionId} .swiper .product-card .media img, #${sectionId} .swiper .product-card .media svg`
    );

    if (mediaElement) {
      const height = mediaElement.getBoundingClientRect().height;
      document
        .querySelectorAll(`#${sectionId} .swiper-button`)
        .forEach((button) => {
          button.style.top = height / 2 + "px";
        });
    }
  }

  function toBoolean(string) {
    return string === "true" ? true : false;
  }
  if (document.querySelector("product-recommendations") !== null) {
    const initslider = setInterval(() => {
      if (
        document
          .querySelector("product-recommendations")
          .querySelector(".swiper") !== null
      ) {
        if (
          document
            .querySelector("product-recommendations")
            .querySelector(".swiper")
            .classList.contains("swiper-initialized")
        ) {
          clearInterval(initslider);
        }
        productSlider();
      }
    }, 100);
  }
  document.addEventListener("DOMContentLoaded", function () {
    productSlider();
    document.addEventListener("shopify:section:load", function () {
      productSlider();
    });
  });
})();

// cart:refresh

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-icon-bubble", selector: "#cart-icon-bubble" },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".js-contents" },
    { id: "main-cart-footer", selector: ".js-contents" },
    { id: "cart-live-region-text", selector: ".shopify-section" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});
